import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/tramos`, options).then(response => {
    return {
      list: response.data.data,
      meta: response.data.meta
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/tramos/${id}`, options)
    .then(response => {
      let tramo = jsona.deserialize(response.data);
      delete tramo.links;
      return tramo;
    });
}

function add(tramo) {
  const payload = jsona.serialize({
    stuff: tramo,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/tramos`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(tramo) {
  const payload = jsona.serialize({
    stuff: tramo,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .patch(`${url}/tramos/${tramo.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function activate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/tramos/activate/${id}`, options);
}

function deactivate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/tramos/deactivate/${id}`, options);
}

function listActive(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/tramos/listActive`, options).then(response => {
    return {
      listActive: jsona.deserialize(response.data),
    };
  });
}

export default {
  list,
  get,
  add,
  update,
  activate,
  deactivate,
  listActive
};
